import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from 'prosemirror-state';

interface NoCopyPasteOptions {
  disableCopy: boolean;
  disablePaste: boolean;
  onDisabledCopy?: () => void;
  onDisabledPaste?: () => void;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    noCopyPaste: {
      updateDisableCopy: (disableCopy: boolean) => ReturnType;
      updateDisablePaste: (disablePaste: boolean) => ReturnType;
    };
  }
}

const NoCopyPaste = Extension.create<NoCopyPasteOptions>({
  name: 'noCopyPaste',

  addOptions() {
    return {
      disableCopy: false,
      disablePaste: false,
      onDisabledCopy: () => {},
      onDisabledPaste: () => {},
    };
  },

  addStorage() {
    return {
      onDisabledCopy: this.options.onDisabledCopy,
      onDisabledPaste: this.options.onDisabledPaste,
    };
  },

  addCommands() {
    return {
      updateDisableCopy: (disableCopy: boolean) => () => {
        this.options.disableCopy = disableCopy;

        // Force update
        this.editor.view.updateState(this.editor.state);
        return true;
      },
      updateDisablePaste: (disablePaste: boolean) => () => {
        this.options.disablePaste = disablePaste;

        // Force update
        this.editor.view.updateState(this.editor.state);
        return true;
      },
    };
  },

  addProseMirrorPlugins() {
    const pluginKey = new PluginKey('noCopyPastePlugin');

    return [
      new Plugin({
        key: pluginKey,
        props: {
          handleDOMEvents: {
            copy: (_view, event) => {
              if (this.options.disableCopy) {
                event.preventDefault();
                this.storage.onDisabledCopy?.();
                return true;
              }
              return false;
            },
            cut: (_view, event) => {
              if (this.options.disableCopy) {
                event.preventDefault();
                this.storage.onDisabledCopy?.();
                return true;
              }
              return false;
            },
            paste: (_view, event) => {
              if (this.options.disablePaste) {
                event.preventDefault();
                this.storage.onDisabledPaste?.();
                return true;
              }
              return false;
            },
            drop: (_view, event) => {
              if (this.options.disablePaste) {
                event.preventDefault();
                this.storage.onDisabledPaste?.();
                return true;
              }
            },
          },
        },
      }),
    ];
  },
});

export default NoCopyPaste;
